// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import VipStatus from "components/user/VipStatus";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import { TogglePreferences } from "./TogglePreferences";

// ** Utils & Helpers
import formatMessage from "utils/formatMessage";

// #####################################################

const VeryficationAndVip = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const user = useSelector((state) => state.globalUser);
	const preferences = useSelector(
		(state) => state.userpanelSettings?.preferences,
	);

	// #####################################################

	return (
		<Block flex column>
			<TogglePreferences
				tooltipText={
					user?.status_vip < 3 &&
					t(
						"userpanel:settings.preferences.vip.tooltips.showMyStatus",
					)
				}
				toggled={state.verifyVipShowMyStatus.status}
				disabled={!preferences?.verifyVipShowMyStatus?.enabled}
				dispatchAction={() =>
					dispatch({
						type: "SET",
						field: "verifyVipShowMyStatus",
						special: true,
					})
				}
				text={formatMessage(
					t("userpanel:settings.preferences.vip.showMyStatus"),
					{
						status:
							user?.status_vip > 2 ? (
								<span
									style={{
										marginLeft: "0.25rem",
									}}
								>
									{t(
										`common:statusVipWithoutAccountSuffix.${user.status_vip}`,
									)}
									<VipStatus
										status={user.status_vip}
										key="userpanel:payments.payments.supervip.desc1-1"
										height={14}
									/>
								</span>
							) : (
								<>
									<span
										style={{
											margin: "0.25rem",
										}}
									>
										{t(
											`common:statusVipWithoutAccountSuffix.3`,
										)}
										<VipStatus
											status={3}
											key="userpanel:payments.payments.supervip.desc1-1"
											height={14}
											noPad
											leftPad={1}
										/>
									</span>

									<span
										style={{
											display: "inline-block",
											marginRight: "0.25rem",
										}}
									>
										{t(`userpanel:settings:preferences:or`)}
									</span>

									<span>
										{t(
											`common:statusVipWithoutAccountSuffix.5`,
										)}
										<VipStatus
											status={5}
											key="userpanel:payments.payments.supervip.desc1-2"
											height={14}
										/>
									</span>
								</>
							),
					},
				)}
			/>

			<TogglePreferences
				tooltipText={
					!preferences?.verifyVipRenewVipAutomatically?.enabled &&
					t("userpanel:settings.preferences.vip.tooltips.renew")
				}
				toggled={state.verifyVipRenewVipAutomatically.status}
				disabled={!preferences?.verifyVipRenewVipAutomatically?.enabled}
				dispatchAction={() =>
					dispatch({
						type: "SET",
						field: "verifyVipRenewVipAutomatically",
						special: true,
					})
				}
				text={formatMessage(
					t(
						"userpanel:settings.preferences.vip.renewVipAutomatically",
					),

					{
						status1: (
							<VipStatus status={3} key="vip-3" height={14} />
						),
						status2: (
							<VipStatus
								status={5}
								key="superVip-5"
								height={14}
							/>
						),
					},
				)}
				noMarginBottom
			/>
		</Block>
	);
};

// #####################################################

export default VeryficationAndVip;

// #####################################################
